(() => {
  const DESKTOP = window.matchMedia('(min-width: 700px)');
  let frame = 0;

  function equalizeGrid(grid) {
    const cards = [...grid.querySelectorAll(':scope > .dk-hud-card')];

    cards.forEach((card) => card.style.removeProperty('--dk-row-title-height'));
    if (!DESKTOP.matches || cards.length < 2) return;

    const rows = new Map();
    cards.forEach((card) => {
      const title = card.querySelector('.dk-hud-card__title');
      if (!title) return;
      const rowKey = Math.round(card.getBoundingClientRect().top);
      const row = rows.get(rowKey) || [];
      row.push({ card, title });
      rows.set(rowKey, row);
    });

    rows.forEach((row) => {
      const tallest = Math.ceil(Math.max(...row.map(({ title }) => title.getBoundingClientRect().height)));
      row.forEach(({ card }) => card.style.setProperty('--dk-row-title-height', `${tallest}px`));
    });
  }

  function refresh() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      document.querySelectorAll('.dk-collection .dk-grid, .dk-search-page__grid').forEach(equalizeGrid);
    });
  }

  window.addEventListener('resize', refresh, { passive: true });
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  new MutationObserver(refresh).observe(document.documentElement, { childList: true, subtree: true });
  if (document.fonts?.ready) document.fonts.ready.then(refresh);
})();
